

import styled from "styled-components"
import { motion } from 'framer-motion';
import getPastDateAndTime from "../../helper/date/getPastDateAndTime";
import { useSelector } from "react-redux";

const Container = styled(motion.div)`
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 12px;
    
    .left-side-item{
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding-bottom: 8px;
        border-bottom: 1px solid ${({theme}) => theme.mainTextColor};

        &:first-child{
            margin-top: 20px;
        }

        &:last-child{
            margin-bottom: 20px;
        }

        h4{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);
        }

        span{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
        }
    }    
`


const variants = {
    open: { height: 'auto', opacity: 1 },
    collapsed: { height: 0, opacity: 0 },
};

const TopPagesTamamlananMapLeftSideContentSection = ({ activeTabId, tabId}) => {

    
    const {
        topPagesMapSingleTamamlananShipmentItemLocationList,
        topPagesMapTamamlananShipmentItemCurrentLocationData
    } = useSelector(state => state.topPagesMap)

    
    const getOrtSpeed = () => {
        const filteredList = topPagesMapSingleTamamlananShipmentItemLocationList.filter(item => {
            return item.speed >= 1
        })
        
        const total = filteredList.reduce((acc, current) => acc + current.speed * 3.6, 0);
        return total / filteredList.length;

    }

    const getTopSpeed = () => {
        return Math.max(...topPagesMapSingleTamamlananShipmentItemLocationList.map(item => item.speed  * 3.6)); 
    }


  return (
    <Container
        initial="collapsed"
        animate={activeTabId === tabId ? 'open' : 'collapsed'}
        variants={variants}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
    >
        <div className="left-side-item">
            <h4>Sürücü</h4>
            <span>{topPagesMapTamamlananShipmentItemCurrentLocationData.driverInfo.driverName}</span>
        </div>

        <div className="left-side-item">
            <h4>Telefon</h4>
            <span>{topPagesMapTamamlananShipmentItemCurrentLocationData.driverInfo.driverPhoneNumber}</span>
        </div>

        <div className="left-side-item">
            <h4>Sefer Başlangıç Tarih Saat</h4>
            <span>{topPagesMapSingleTamamlananShipmentItemLocationList[topPagesMapSingleTamamlananShipmentItemLocationList.length -1]?.createdDate && getPastDateAndTime(topPagesMapSingleTamamlananShipmentItemLocationList[topPagesMapSingleTamamlananShipmentItemLocationList.length -1]?.createdDate)?.formattedDate}  {topPagesMapSingleTamamlananShipmentItemLocationList[topPagesMapSingleTamamlananShipmentItemLocationList.length -1] && getPastDateAndTime(topPagesMapSingleTamamlananShipmentItemLocationList[topPagesMapSingleTamamlananShipmentItemLocationList.length -1]?.createdDate)?.formattedTime}</span>
        </div>

        <div className="left-side-item">
            <h4>Ortalama Hız</h4>
            <span>{parseInt(getOrtSpeed())} km/sa</span>
        </div>

        <div className="left-side-item">
            <h4>En Yüksek Hız</h4>
            <span>{parseInt(getTopSpeed())} km/sa</span>
        </div>
    </Container>
  )
}

export default TopPagesTamamlananMapLeftSideContentSection
